import { useContext } from 'react';

import { AuthContext, type AuthState } from './AuthContext';

export function useAuthSession(): AuthState {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error('useAuthSession должен вызываться внутри AuthProvider');
  }

  return context;
}
